import { FiExternalLink } from "react-icons/fi";
import { SiLeetcode } from "react-icons/si";

import { profile } from "../../data/profile";
import {
  parseSubmissionCalendar,
  totalSubmissions,
  useLeetCode,
} from "../../lib/leetcode";
import Card from "./Card";
import LeetCodeCalendar from "./LeetCodeCalendar";

const StatBlock = ({ value, label }) => (
  <div className="lc-activity-stat">
    <b>{value ?? "—"}</b>
    <span>{label}</span>
  </div>
);

// Dashboard card: live LeetCode submission heatmap + a few headline stats,
// mirroring the GitHub contributions card.
const LeetCodeActivity = () => {
  const username = profile.leetcodeUsername;
  const cal = useLeetCode("calendar", username);
  const solved = useLeetCode("solved", username);

  const calMap = cal.data ? parseSubmissionCalendar(cal.data) : {};
  const submissions = totalSubmissions(calMap);
  const solvedCount =
    solved.data?.solvedProblem ?? solved.data?.totalSolved ?? null;

  const showSkeleton = cal.loading && !cal.data;
  const showError = !cal.loading && cal.error && !cal.data;
  const profileUrl = `https://leetcode.com/u/${username}/`;

  return (
    <Card
      title={
        <span className="lc-activity-title">
          <SiLeetcode /> LeetCode Activity
        </span>
      }
      className="activity-card lc-activity-card"
      action={
        <a className="see-all" href={profileUrl} target="_blank" rel="noreferrer">
          Profile <FiExternalLink />
        </a>
      }
    >
      {showSkeleton ? (
        <div className="lccal-skeleton skeleton-shimmer" />
      ) : showError ? (
        <div className="lc-activity-error">
          Couldn&apos;t reach LeetCode right now.{" "}
          <a href={profileUrl} target="_blank" rel="noreferrer">
            View profile
          </a>
          .
        </div>
      ) : (
        <>
          <div className="lc-activity-stats">
            <StatBlock value={solvedCount} label="Solved" />
            <StatBlock value={cal.data?.streak} label="Max streak" />
            <StatBlock value={cal.data?.totalActiveDays} label="Active days" />
            <StatBlock value={submissions} label="Submissions" />
          </div>
          <LeetCodeCalendar calendarData={cal.data} />
          {cal.stale && (
            <div className="lc-note">Showing recently cached activity.</div>
          )}
        </>
      )}
    </Card>
  );
};

export default LeetCodeActivity;
